import React from 'react'
import {Link} from "react-router-dom"

function ServiceBtn(props) {
    return (
        <Link className="btn btn-xs btn-primary" to={props.to}><i className="bx bx-search" style={{"marginRight":"5px"}}></i>Run</Link>
    )
}

export default ServiceBtn
